import React from "react"

import BrokerGuidancePanel from "./BrokerGuidancePanel"
import {
  ChecklistRow,
  GuidanceAccordionBody,
  GuidanceBlock,
  GuidanceIntro,
} from "./ibkrGuidanceShared"

export interface Mt5TradeHistoryGuidanceProps {
  compact?: boolean
}

const Mt5TradeHistoryGuidance = ({
  compact = false,
}: Mt5TradeHistoryGuidanceProps): React.ReactElement => {
  return (
    <BrokerGuidancePanel
      title="How to export your MT5 Trade History Report"
      compact={compact}
      collapsible
    >
      <GuidanceAccordionBody>
        <GuidanceIntro className="!mb-0">
          In MetaTrader 5, export a Trade History Report as Excel (.xlsx only), then upload it here.
        </GuidanceIntro>

        <GuidanceBlock title="Export steps">
          <ChecklistRow className="!mb-0">
            Open the History tab → right-click → choose Report
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Set your period, then save as Excel (.xlsx only)
          </ChecklistRow>
          <ChecklistRow className="!mb-0">Upload the downloaded file here</ChecklistRow>
        </GuidanceBlock>

        <GuidanceBlock title="Things to know">
          <ChecklistRow className="!mb-0">
            Company and server names in the report are stored as metadata only. Trades are tied to
            the account login number from the report.
          </ChecklistRow>
          <ChecklistRow className="!mb-0">
            Times in the file are usually your broker&apos;s server time. If your watch shows 20:00
            but the report shows 15:00, pick the timezone that matches the numbers in the file
            (check MT5: Tools → Options → Server).
          </ChecklistRow>
        </GuidanceBlock>
      </GuidanceAccordionBody>
    </BrokerGuidancePanel>
  )
}

export default Mt5TradeHistoryGuidance
